import React, { useEffect, useRef, useState } from 'react'
import { graphql } from 'gatsby'
import Img from "gatsby-image"

import Layout from '../components/layout'
import SEO from '../components/seo'
import Btn from '../components/btn'

const TemplatePost = ({location, data}) => {

    const title = useRef(null)
    const [titleHeight, setTitleHeight] = useState('0px')

    useEffect(() => {
        setTitleHeight(title.current.clientHeight)
    }, [])

    const { markdownRemark: post, site} = data

    return (
        <Layout>
            <SEO title={ post.frontmatter.title } description={ post.excerpt } thumbnail={post.frontmatter.thumbnail.childImageSharp.sizes.src } />
            <div className="TemplatePostContainer">
                <div className="left">
                    <div className="stickyContainer">
                        <h1 ref={title}>
                            { post.frontmatter.title }
                        </h1>
                        <h2>
                            { post.frontmatter.date }
                        </h2>
                        <h3>
                            { post.frontmatter.category }    
                        </h3>
                        <h4>
                            { post.timeToRead + ' min read' }  
                        </h4>
                        <Img fluid={post.frontmatter.thumbnail.childImageSharp.fluid} className="thumbnail" style={{height: `calc(100vh - (${titleHeight}px + 3 * (1em + 4px) + 10px * 2 + 20px))`}} />
                    </div>
                </div>

                <div className="right">
                    <div className="content" dangerouslySetInnerHTML={{__html: post.html}} style={{marginTop: `calc(${titleHeight}px + 4px)`}}></div>
                    <div className="btnContainer">
                        <Btn link={`https://twitter.com/intent/tweet?url=${site.siteMetadata.siteUrl + post.fields.slug}&text=${post.frontmatter.title}`} text="Share on Twitter" />
                        <Btn link={`https://www.facebook.com/sharer/sharer.php?u=${site.siteMetadata.siteUrl + post.fields.slug}`} text="Share on Facebook" />
                    </div>
                </div>
            
            </div>
        </Layout>
    )
}


export const data = graphql`
    query GetPost ($id: String) {
        markdownRemark(id: {eq: $id}) {
            id
            fields {
                slug
            }
            frontmatter {
                title
                date(formatString: "DD MMMM, YYYY")
                category
                thumbnail {
                    childImageSharp {
                        fluid(maxWidth: 900) {
                            ...GatsbyImageSharpFluid
                        }
                        sizes(maxWidth: 900) {
                            ...GatsbyImageSharpSizes
                          }
                    }
                }
            }
            html
            excerpt
            timeToRead
        }

        site {
            id
            siteMetadata {
              siteUrl
            }
          }

    }
    
`


export default TemplatePost